import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

function Portal(props) {

  if (typeof document !== 'object') {
    return null;
  }

  return ReactDOM.createPortal(props.children, document.body);

}

export default Portal;